"use strict";

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var genSummaryStyle = function genSummaryStyle(token) {
  var _$concat;

  var componentCls = token.componentCls,
      lineWidth = token.lineWidth,
      tableBorderColor = token.tableBorderColor;
  var tableBorder = "".concat(lineWidth, "px ").concat(token.lineType, " ").concat(tableBorderColor);
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), (_$concat = {}, _defineProperty(_$concat, "".concat(componentCls, "-summary"), {
    position: 'relative',
    zIndex: token.zIndexTableFixed,
    background: token.tableBg,
    '> tr': {
      '> th, > td': {
        borderBottom: tableBorder
      }
    }
  }), _defineProperty(_$concat, "div".concat(componentCls, "-summary"), {
    boxShadow: "0 -".concat(lineWidth, "px 0 ").concat(tableBorderColor)
  }), _$concat));
};

var _default = genSummaryStyle;
exports.default = _default;